import type { BookingProposalItemRecord } from '@navio/nsdk';
import { catalogPriceMapKey, type ProposalCatalogPrice } from 'noddi-util';

/** Gross total of a proposal's cart: catalog price first, then the proposal's ad hoc price, then list price. */
export const getProposalCartTotal = (
  bookingProposalItems: BookingProposalItemRecord[],
  priceByCartKey: Map<string, ProposalCatalogPrice>
) =>
  bookingProposalItems.reduce(
    (sum, item) =>
      sum +
      item.salesItemsWithQuantity.reduce((lineSum, si) => {
        const catalog = priceByCartKey.get(catalogPriceMapKey(item.car.licensePlate.number, si.salesItem.id));
        const unit = catalog?.grossPrice ?? si.priceAdHoc?.priceGross ?? si.salesItem.price.priceGross;
        return lineSum + unit.amount * si.quantity;
      }, 0),
    0
  );
